<template>
  <div class="city-select">
    <select style="display: none" @change="getCities" v-model="currentProvince">
      <option v-for="option in provinces" :value="option.area_title">
        {{ option.area_title }}
      </option>
    </select>
    <select @change="getAreas" v-model="currentCity">
      <option v-for="option in cities" :value="option.area_title">
        {{ option.area_title }}
      </option>
    </select>
    <select @change="getAreasName" v-model="currentArea">
      <option v-for="option in areas" :value="option.area_title">
        {{ option.area_title }}
      </option>
    </select>
  </div>
</template>
<script>
  /**
   *  省 市 区/县城  三联动选择器
   */
  import Vue from 'vue'
  export default {
    props:{
      DISTRICTS: { type: Array, default:()=>[] },
      province: { type: String, default: '' },
      city: { type: String, default: '' },
      area: { type: String, default: '' },
    },
    data() {
      return {
        provinces: [],
        cities: [],
        areas: [],
        currentProvince: this.province,
        currentCity: this.city,
        currentArea: this.area,
      }
    },
    created() {

    },
    watch: {
      province() {
        this.currentProvince = this.province
        this.cities = this.getCitiesDistricts(this.getProvinceCode(this.currentProvince))
      },
      city() {
        this.currentCity = this.city
        this.areas = this.getAreasDistricts(this.getProvinceCode(this.currentProvince),this.getCityCode(this.getProvinceCode(this.currentProvince),this.currentCity))
      },
      area() {
        this.currentArea = this.area
      },
      DISTRICTS(){
        this.updata()
      }
    },
    methods: {
      updata () { // 既然created只会执行一次，但是又想监听改变的值做其他事情的话，只能搬到这里咯
        this.provinces = this.getProvincesDistricts()
        this.cities = this.province ? this.getCitiesDistricts(this.getProvinceCode(this.province)) : []
        this.areas = this.city ? this.getAreasDistricts(this.getProvinceCode(this.province),this.getCityCode(this.getProvinceCode(this.province),this.city)) : []
      },
      getCities() {
        this.cities = this.getCitiesDistricts(this.getProvinceCode(this.currentProvince))
        this.currentCity = this.cities[0].area_title
        this.getAreas()
        Vue.nextTick(() => {
          this.$emit('input', this.info)
        })
      },
      getAreas() {
        this.areas = this.getAreasDistricts(this.getProvinceCode(this.currentProvince),this.getCityCode(this.getProvinceCode(this.currentProvince),this.currentCity))
        this.currentArea = this.areas[0].area_title
        Vue.nextTick(() => {
          this.$emit('input', this.info)
        })
      },
      getAreasName() {
        Vue.nextTick(() => {
          this.$emit('input', this.info)
        })
      },
      getProvinceCode(province) {
        for(let x in this.DISTRICTS){
          if(province === this.DISTRICTS[x].area_title){
            return x
          }
        }
      },
      getCityCode(pcode,city) {
        for(let y in this.DISTRICTS[pcode].province){
          if(city === this.DISTRICTS[pcode].province[y].area_title){
            return y
          }
        }
      },
      getProvincesDistricts(){
        return this.DISTRICTS
      },
      getCitiesDistricts(pcode){
        return this.DISTRICTS[pcode].province
      },
      getAreasDistricts(pcode,ccode){
        return this.DISTRICTS[pcode].province[ccode].city
      }
    },
    computed: {
      info() {
        return {
          province: this.currentProvince,
          city: this.currentCity,
          area: this.currentArea
        }
      }
    },

  }
</script>
<style scoped>
  .city-select {
    padding: 0 5px;
  }
  .city-select select { appearance:none; -moz-appearance:none; -webkit-appearance:none; height: 30px; padding: 0 19px 0 5px; margin-right: 5px;cursor: pointer;color: #666;font-size: 14px; background: url(../../assets/imgs/select2.png) no-repeat scroll calc(100% - 4%) center transparent;}
  .city-select select option { color: #666;font-size: 14px; }
  .city-select select {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  .city-select select::-ms-expand{
    visibility: hidden;
  }
</style>




// WEBPACK FOOTER //
// src/components/commons/XkuaidiCity.vue